import React, { Component } from 'react'
import moment from 'moment-timezone'
import { graphql } from 'react-apollo'
import { translate } from "react-i18next"
import { connect } from 'react-redux'

import getOccurrencesQuery from 'graphql/queries/getOccurrences'

import './recurrenceSummary.css'

class RecurrenceSummary extends Component {
  recurrenceDescription(){
    const { t, time, timezone, service } = this.props

    if (!service.recurrence) {
      return null
    }
    const { frequency, byweekday, count } = service.recurrence

    // ON WEEKDAY
    const weekday = byweekday.length > 0 ? moment.tz(time, timezone).format('dddd') : null
    const onWeekday = weekday ? t('on-weekday', { weekday }) : ''

    // UNTIL: X times / indefinitely
    const until = count > 0 ? t('x-times', { count }) : t('indefinitely')

    // This appointment will repeat {{FREQUENCY}} on {{ONWEEKDAY}} {{UNTIL}}
    return (
      <p>{ t('appointment-repeat') } { t(frequency.toLowerCase()) } { onWeekday } { until }</p>
    )
  }

  render() {
    const { dateFormat, t, data, timezone } = this.props

    if (data.loading) {
      return (
        <span>Calculating next occurrences...</span>
      )
    }

    const occurrences = data.recurringOccurrences.occurrences.slice(1)

    return (
      <div className="next-occurrences">
        { this.recurrenceDescription() }
        <h5>{ t('next-x-occurrences', { count: occurrences.length }) }</h5>
        <ul>
        { occurrences.map(occurrence => (
          <li>{ moment.tz(occurrence, timezone).format(`${dateFormat.date} ${dateFormat.time}`) }</li>
        )) }
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  time: state.time,
  timezone: state.timezone,
})
export default connect(mapStateToProps)(graphql(getOccurrencesQuery, {
  options: (props) => ({
    variables: {
      recurrence: props.service.recurrence,
      date: props.time,
      count: props.count+1,
      timezone: props.business.timezone,
    }
  })
})(translate("translations")(RecurrenceSummary)))
